import type { CSVValidationError } from "@tellescope/utils";

/**
 * One CSV validation error or warning, ready to display.
 *
 * Row numbers are 1-indexed and `0` means the problem is with the header or the file as a whole
 * ("CSV file is empty", "Missing required columns"), so those are shown as the bare message rather
 * than prefixed with a row that does not exist.
 *
 * @param issue - the validation error or warning to display
 * @param withRow - renders the row-prefixed form; the caller supplies it so the `t()` call stays a
 *   static literal at the call site, which is what the i18n key extractor scans for
 */
export const formatCsvIssue = (issue: CSVValidationError, withRow: (row: number, message: string) => string): string =>
  issue.row > 0 ? withRow(issue.row, issue.message) : issue.message;
